import { c as _c } from "react/compiler-runtime";
import type IDateGroup from "src/components/dateselector/IDateGroup";
import { isSameDay, format } from "date-fns";
import classNames from 'classnames';
import { locale } from "src/lib/locale/date-fns";
import styles from './DateItem.module.css';

//#region [Props]
type DateItemProps = {
  month?: IDateGroup;
  date: Date;
  selectedDate: Date;
  changeDate: (date: Date) => void;
};
//#endregion

//#region [Component]
export default function DateItem(t0) {
  const $ = _c(19);
  const {
    month,
    date,
    selectedDate,
    changeDate
  } = t0;
  let t1;
  if ($[0] !== date || $[1] !== month?.dates) {
    t1 = month?.dates?.find(elem => isSameDay(elem, date));
    $[0] = date;
    $[1] = month?.dates;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const clickable = !!t1;
  const t2 = !clickable;
  let t3;
  if ($[3] !== changeDate || $[4] !== date) {
    t3 = () => {
      changeDate(date);
    };
    $[3] = changeDate;
    $[4] = date;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== clickable || $[7] !== date || $[8] !== selectedDate) {
    t4 = classNames(styles.SDateDisplay, {
      [styles.clickable]: clickable,
      [styles.selected]: isSameDay(date, selectedDate)
    });
    $[6] = clickable;
    $[7] = date;
    $[8] = selectedDate;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== date) {
    t5 = format(date, "d", {
      locale
    });
    $[10] = date;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t6) {
    t7 = <button className={styles.SDateItemButton} disabled={t2} onClick={t3}>{t6}</button>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}

//#endregion

//#region [Styles]
//#endregion